import { useCallback, useState } from "react";
import { toast } from "sonner";
import { initialPatch } from "@/lib/patchState";
import { useHostMessages, webviewHost } from "@/hooks/useHostMessages";
import { useDemoPatch } from "@/hooks/useDemoPatch";

export function usePatcher() {
  const [state, setState] = useState(initialPatch);
  const [hostFeatures, setHostFeatures] = useState([]);
  const isHost = !!webviewHost();

  const post = useCallback((msg) => webviewHost()?.postMessage(msg), []);
  useHostMessages(isHost, post, setState, setHostFeatures);
  const runDemo = useDemoPatch(setState);

  const check = useCallback(() => (isHost ? post({ type: "check" }) : runDemo()), [isHost, post, runDemo]);
  const start = useCallback(() => post({ type: "start" }), [post]);
  const config = useCallback((exe) => {
    if (hostFeatures.includes("config")) return post({ type: "config", exe });
    toast.error("Stara wersja patchera", { description: "Pobierz nowy Metin2Patcher z panelu admina i zbuduj go ponownie." });
  }, [post, hostFeatures]);

  return { state, isHost, check, start, config, post };
}
